export const MAX_WYSIWYG_LENGTH = 5000;
export const MAX_COMMENT_LENGTH = 1000;
export const MAX_LABEL_LENGTH = 25;
export const MAX_PROJECT_TYPE_LENGTH = 50;

export const quillBlocksRegex = /(<pre.*?>[^~]*?<\/pre>)|(<p.*?>[^~]*?<\/p>)|(<h[123].*?>[^~]*?<\/h[123]>)|(<blockquote.*?>[^~]*?<\/blockquote>)|(<li.*?>[^~]*?<\/li>)/g

export const WYSIWYG_FORMATS = [
  "bold",
  "italic",
  "underline",
  "strike",
  "code",
  "link",
  "header",
  "list",
  "blockquote",
  "code-block",
  "indent",
  "background",
];
export const WYSIWYG_FORMATS_WITH_MENTIONS = [
  "bold",
  "italic",
  "underline",
  "strike",
  "code",
  "link",
  "header",
  "list",
  "blockquote",
  "code-block",
  "indent",
  "background",
  "mention",
];